import { NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';
import { CommonModule } from "@angular/common";
import { LoginComponent } from "./login/login.component";
import { TreinoComponent } from "./user/treino/treino.component";
import { TreinoGestaoComponent } from "./user/treino-gestao/treino-gestao.component";
import { AdmTemaComponent } from "./admin/adm-tema/adm-tema.component";
import { AdmMateriaComponent } from "./admin/adm-materia/adm-materia.component";
import { AdmHomeComponent } from "./admin/adm-home/adm-home.component";
import { AdmLinkComponent } from "./admin/adm-link/adm-link.component";
import { AdmVoleiProtocolComponent } from "./admin/adm-volei-protocol/adm-volei-protocol.component";
import { ListFilesComponent } from "./admin/list-files/list-files.component";
import { SharedModule } from "../shared/shared.module";
import { AdminGuard } from "../core/guards/admin.guard";
import { AuthGuard } from "../core/guards/auth.guard";

import { AdmComentarioRespostaComponent } from "./admin/adm-comentario-resposta/adm-comentario-resposta.component";
import { CoreModule } from "../core/core.module";
import { AdminExercicioComponentComponent } from "./admin/admin-exercicio-component/admin-exercicio-component.component";
import { AdminAbdominalComponent } from "./admin/admin-abdominal/admin-abdominal.component";
import { AdminCardioComponent } from "./admin/admin-cardio/admin-cardio.component";
import { TreinoDashboardComponent } from './user/treino-dashboard/treino-dashboard.component';
import { AdminCinemaComponent } from './admin/admin-cinema/admin-cinema.component';

@NgModule({
  declarations: [
    LoginComponent,
    TreinoComponent,
    TreinoGestaoComponent,
    AdmTemaComponent,
    AdmMateriaComponent,
    AdmComentarioRespostaComponent,
    AdmHomeComponent,
    AdmLinkComponent,
    AdmVoleiProtocolComponent,
    AdminExercicioComponentComponent,
    AdminAbdominalComponent,
    AdminCardioComponent,
    ListFilesComponent,
    TreinoDashboardComponent,
    AdminCinemaComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    RouterModule.forChild([
      { path: 'login', component: LoginComponent },
      { path: 'treino', component: TreinoComponent, canActivate: [AuthGuard] },
      { path: 'treino-gestao', component: TreinoGestaoComponent, canActivate: [AuthGuard] },
      { path: 'treino-dashboard', component: TreinoDashboardComponent, canActivate: [AuthGuard] },
      { path: 'adm/link', component: AdmLinkComponent, canActivate: [AdminGuard] },
      { path: 'adm/tema', component: AdmTemaComponent, canActivate: [AdminGuard] },
      { path: 'adm/exercicio', component: AdminExercicioComponentComponent, canActivate: [AdminGuard] },
      { path: 'adm/abdominal', component: AdminAbdominalComponent, canActivate: [AdminGuard] },
      { path: 'adm/cardio', component: AdminCardioComponent, canActivate: [AdminGuard] },
      { path: 'adm/cinema', component: AdminCinemaComponent, canActivate: [AdminGuard] },
      { path: 'adm/materia', component: AdmMateriaComponent, canActivate: [AdminGuard] },
      { path: 'adm/home', component: AdmHomeComponent, canActivate: [AdminGuard] },
      { path: 'adm/volei-protocol', component: AdmVoleiProtocolComponent, canActivate: [AdminGuard] },

    ])
  ]
})
export class AppSecureModule { }
